import { combineEpics } from "redux-observable";
import { distinctUntilChanged, filter, map, merge } from "rxjs/operators";

import { actionCreators, isOfActions } from "../actions";
import { getOpenRoomIds } from "../reducers/rooms";
import { Epic } from "../utils/types";

// epics

const onSortCriteria: Epic = (action$, state$, { App }) =>
    action$.pipe(
        filter(
            isOfActions([
                //
                actionCreators.onRoster,
                actionCreators.rosterSortMoratoriumOff,
            ])
        ),
        merge(
            state$.pipe(
                map(getOpenRoomIds),
                distinctUntilChanged()
            )
        ),
        map(() => {
            const state = state$.value;
            const joinedRooms = getOpenRoomIds(state);
            return actionCreators.doSortRoster({
                respectSortMoratorium: true,
                joinedRooms,
            });
        })
    );

export const rosterSortEpic = combineEpics(onSortCriteria);
